import Vue from 'vue'
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    state: {
        token: null,
        user: null
    },
    mutations: {
        setToken(state, payload) {
            state.token = payload.token
        },
        setUser(state, payload) {
            state.user = payload.user
        }
    }
})